import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import dayjs from "dayjs";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  public static ENABLED = true;

  constructor(private http: HttpClient) {}

  sendFeedback(score: number, extras: string[], token?: string) {
    if (token) {
      return this.http.post<void>(`${environment.apiBase}/v1.0/feedback/token/${token}`, {
        score,
        extras,
      });
    } else {
      return this.http.post<void>(`${environment.apiBase}/v1.0/feedback`, {
        score,
        extras,
      });
    }
  }

  getLastFeedback(token?: string) {
    if (token) {
      return this.http.get<string | null>(`${environment.apiBase}/v1.0/feedback/at/token/${token}`);
    } else {
      return this.http.get<string | null>(`${environment.apiBase}/v1.0/feedback/at${token ? '?token=' + token : ''}`);
    }
  }

  postpone() {
    localStorage.setItem('postpone-feedback', dayjs().add(45, 'day').format('YYYY-MM-DD'));
  }

  canAsk() : Observable<boolean> {
    const postponedUntil = localStorage.getItem('postpone-feedback');
    if (!postponedUntil) return of(true);

    return of(dayjs().isAfter(dayjs(postponedUntil)));
  }
}
